import { FilterItem } from "../../types";

export const getDataFromFilterItems = (items: FilterItem[]) => {
  return (
    items?.map(({ name, value }) => ({
      groupName: name as string,
      [name as string]: { [name as string]: value },
    })) || []
  );
};
